export const queryKeys = {
    ORDERS: 'orders',
    PAYIN_ORDER: 'payin_order',
    PAYIN_ORDERS: 'payin_orders',
    PAYOUT_ORDER: 'payout_order',
    PAYOUT_ORDERS: 'payout_orders',
    PAYIN_ORDERS_COUNT: 'payin_orders_count',
    PAYOUT_ORDERS_COUNT: 'payout_orders_count',
} as const;
